import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../core/services";

@Injectable({
  providedIn: 'root'
})
export class UserApi {
    private readonly httpService = inject(HttpService);

    getUser(){
        return this.httpService.get("user", false);
    }

    getAllUsers(){
        return this.httpService.get("users", false);
    }

    createUser(payload: { name: string; email: string; phone: string }){
        return this.httpService.post("users", payload, false);
    }

    updateOrganizationUser(userId: string, payload: { name: string; email: string; phone: string }) {
        return this.httpService.put(`users/${userId}`, payload, false);
    }

    updateOrganizationUserStatus(userId: string, isActive: boolean) {
        return this.httpService.patch(`users/${userId}/status`, { is_active: isActive }, false);
    }

    deleteOrganizationUser(userId: string) {
        return this.httpService.delete(`users/${userId}`, false);
    }

    getProfilePhoto(){
        return this.httpService.getBlob("user/profile/photo", true);
    }

    getUserProfilePhoto(userId: string){
        return this.httpService.getBlob(`users/${userId}/profile/photo`, true);
    }

    updateProfile(payload: FormData){
        return this.httpService.putForm("user/profile", payload, false);
    }

    setAvailabilityStatus(status: string){
        const payload = new FormData();
        payload.append('availability_status', status);
        return this.httpService.putForm("user/profile", payload, true);
    }

    removeProfilePhoto(){
        return this.httpService.delete("user/profile/photo", false);
    }

    getWebPushConfig() {
        return this.httpService.get("user/push/config", true);
    }

    saveWebPushSubscription(payload: unknown) {
        return this.httpService.post("user/push/subscriptions", payload, true);
    }

    deleteWebPushSubscription(endpoint: string) {
        return this.httpService.delete(`user/push/subscriptions?endpoint=${encodeURIComponent(endpoint)}`, true, false);
    }

}
